import { useSelector } from 'react-redux'

import Fieldset from 'components/form/fieldset'

import { inviteeNameFormatSelector } from '../../../../../selectors'

import CombinedNameInput from './combined_name_input'
import EmailInput from './email_input'
import SeparatedNameInput from './seperated_name_input'

const InviteeInputs = ({ inviteeName, onInviteeNameChange, inviteeEmail, onInviteEmailChange }) => {
  const inviteeNameFormat = useSelector(inviteeNameFormatSelector)

  const renderNameInput = () => (inviteeNameFormat === 'combined'
    ? (
      <CombinedNameInput
        fullName={inviteeName.full_name}
        onChange={onInviteeNameChange}
      />
    ) : (
      <SeparatedNameInput
        firstName={inviteeName.first_name}
        lastName={inviteeName.last_name}
        onChange={onInviteeNameChange}
      />
    ))
  return (
    <Fieldset>
      {renderNameInput()}
      <EmailInput
        email={inviteeEmail}
        onChange={onInviteEmailChange}
      />

    </Fieldset>
  )
}

export default InviteeInputs
